import { useXHR } from "@sembark-travel/xhr"
import { dataDriveXHR, ISheetFolderForm, TSheetFolder } from "./store"
import { SheetFolderForm } from "./Sheets"
import { useCallback } from "react"

export function CreateFolder({
	onSuccess,
	onCancel,
	initialValues,
	editMode,
}: {
	onSuccess: (item: TSheetFolder) => void
	onCancel: () => void
	initialValues: { name: string; description?: string }
	editMode?: boolean
}) {
	const xhr = useXHR()

	const createTransportServicePriceFolder = useCallback(
		async (sheetFolderData: ISheetFolderForm) => {
			const resp = await dataDriveXHR(xhr).createFolder(sheetFolderData)

			onSuccess(resp)
		},
		[xhr, onSuccess]
	)
	return (
		<SheetFolderForm
			onSubmit={createTransportServicePriceFolder}
			onCancel={onCancel}
			initialValues={initialValues}
			editMode={editMode}
		/>
	)
}
